const getters ={
    isWXConfig: state=>{
        return state.wechat.isConfig;
    },
    isLogin: state=>{
        return state.user.isLogin;
    },
    appName: state=>{
        return state.appInfo.appName;
    },
    ak: state=>{
        return state.appInfo.ak;
    }
};

export default getters;